'use client';

import { useClientTranslation } from '@lib/i18n/client';
import { CruisePriceTable } from '@tuic/web-compositions/my-trips/CruisePriceTable';
import { InfoList } from '@tuic/web-compositions/shared/InfoList';

import { TextButton } from '../../elements/TextButton';

import { CruisePriceSkeleton } from './CruisePriceSkeleton';

import type PrismAPI from '@modules/prism-client/types/prism-types';
import type { ComponentBlock } from '@modules/prism-client/types/types';

export type CruisePriceBlockData = {
  bookingHeading: string;
  cruisePriceTableHeading: string;
  infoList: PrismAPI.CruisePriceBlock['infoList'];
  priceTable: PrismAPI.CruisePriceBlock['priceTable'];
  paymentButton: PrismAPI.CruisePriceBlock['paymentButton'];
};

export const CruisePriceBlock: ComponentBlock<CruisePriceBlockData> = ({
  data,
  fallback,
}) => {
  const { t } = useClientTranslation();

  if (fallback) {
    return <CruisePriceSkeleton />;
  }

  if (!data) {
    return null;
  }

  return (
    <div className="flex flex-col gap-12 md:gap-16 max-w-4xl">
      <section>
        <h2 className="headline-lg text-marine-high-emphasis mb-8">
          {data.bookingHeading}
        </h2>
        <InfoList className="max-w-[28rem]" items={data.infoList} />
      </section>

      <section>
        <h2 className="headline-lg text-marine-high-emphasis mb-10">
          {data.cruisePriceTableHeading}
        </h2>
        <CruisePriceTable
          lineItems={data.priceTable.lineItems}
          priceTotal={data.priceTable.priceTotal}
          t={t}
        />
      </section>

      {data.paymentButton && (
        <div className="ml-auto text-lg">
          <TextButton data={data.paymentButton} />
        </div>
      )}
    </div>
  );
};
